import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter, OnInit, ViewChild, Inject, OnDestroy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AbstractControl, FormControl, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { PrimeNG } from 'primeng/config';
import { DatePicker } from 'primeng/datepicker';
import { FloatLabelModule } from 'primeng/floatlabel';
import { getCurrentLanguage, State } from '../../../shared/standalone-packages/ecap3/core';
import { Observable, Subject, takeUntil } from 'rxjs';
import { select, Store } from '@ngrx/store';

@Component({
    selector: 'app-app-pcx-day-picker',
    templateUrl: './app-pcx-day-picker.component.html',
    styleUrls: ['./app-pcx-day-picker.component.scss'],
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, TranslateModule, FloatLabelModule, DatePicker],
})
export class AppPcxDayPickerComponent implements OnInit, OnDestroy {
    lang$: Observable<string>;
    private destroy$: Subject<boolean> = new Subject<boolean>();
    date: Date[] | undefined;

    @Input() control: FormControl | AbstractControl;
    @Input() label: string;
    @Input() customClass: string;
    @Input() showCalenderIcon = true;
    @Input() showClearButton = false;
    @Output() onDateChanged = new EventEmitter();
    @Input() required: boolean = false;
    @Input() isDisabledInput: boolean = false;
    @Input() minDate = new Date(1971, 1, 1);
    @Input() maxDate = new Date(2050, 1, 1);
    @Input() isTimeShow: boolean = true;
    @Input() appendTo: any = null;
    @ViewChild('calendar') calendar?: DatePicker;
    @Input() dateFormat = 'dd.mm.yy';
    @Input() tabindex: number = 0;
    @Input() isCloseButtonRequired = false;

    constructor(
        @Inject(Store) private store: Store<State>,
        private config: PrimeNG,
        private readonly translateService: TranslateService
    ) {
        this.lang$ = this.store.pipe(select(getCurrentLanguage));

        // primeNG localization
        this.lang$.pipe(takeUntil(this.destroy$)).subscribe(lang => {
            this.translateService.use(lang);

            // get translation from json file then set into primeNG config
            this.translateService
                .get('primeng')
                .pipe(takeUntil(this.destroy$))
                .subscribe(res => {
                    this.config.setTranslation(res);
                });
        });
    }

    public ngOnInit(): void {
        if (this.control.value) {
            this.control.setValue(new Date(this.control.value));
        }
    }

    public onClickCancel(): void {
        if (this.calendar) {
            this.calendar.overlayVisible = false;
        }
    }

    public ngOnDestroy(): void {
        this.destroy$.next(true);
        this.destroy$.complete();
    }
}
